import { render, staticRenderFns } from "./AdvancedColourMatchV2Template.vue?vue&type=template&id=ce5cfc46&"
import script from "./AdvancedColourMatchV2Template.vue?vue&type=script&lang=ts&"
export * from "./AdvancedColourMatchV2Template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports